import { Injectable } from '@angular/core';

import { PermissionsService } from '@app/modules/auth';
import { switchMap, map } from 'rxjs/operators';
import { LocationApiService } from '@app/modules/location-client/location-api.service';
import { combineLatest } from 'rxjs';
import { Asset, LiveApiAsset } from '@app/modules/location-client/location-api.models';
import { LocationFacade } from '@app/modules/location/facade/location.facade';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DataDogService } from '@app/services/data-dog.service';
import { convertToAsset } from '@app/modules/location-client/utilities';
import { DivisionMappingService } from './division-mapping.service';
import { patchAssetData } from '@app/modules/shared/utilities/utilities';
import { SettingsFacade } from '@app/modules/settings/facade/settings.facade';

@Injectable({
  providedIn: 'root'
})
export class SelectedAssetService {
  constructor(
    private permissions: PermissionsService,
    private locationApiSvc: LocationApiService,
    private locationFacade: LocationFacade,
    private divisionMappingService: DivisionMappingService,
    private ddService: DataDogService,
    private settingsFacade: SettingsFacade
  ) {}

  noHomeLocationMsg = 'Unable To Load';

  mergeAssetWithLocation(divisionId: string, asset: Asset): Observable<Asset> {
    if (divisionId) {
      const homeLocation = this.divisionMappingService.getLocationNameById(divisionId) || this.noHomeLocationMsg;
      return of({
        ...asset,
        homeLocation: homeLocation || this.noHomeLocationMsg
      });
    }
    return of({
      ...asset,
      homeLocation: this.noHomeLocationMsg
    });
  }

  getSelectedAssetById(assetId: string): Observable<Asset> {
    let _companyId = null;
    return combineLatest([
      this.locationFacade.getAssetParams(),
      this.locationFacade.getAllVehicles(),
      this.settingsFacade.getDisplaySettings()
    ]).pipe(
      switchMap(([assetParams, vehiclesMap, settings]) => {
        _companyId = assetParams?.companyId;

        return this.locationApiSvc.getSelectedAssetById(_companyId, assetId).pipe(
          switchMap((liveApiAsset: LiveApiAsset) => {
            const asset = patchAssetData(convertToAsset(liveApiAsset), vehiclesMap, settings.assetViewType);
            return this.mergeAssetWithLocation(asset?.divisionId, asset);
          })
        );
      })
    );
  }
}
